// removed by extract-text-webpack-plugin
module.exports = {"container":"container-2Fj5W","header":"header-13Dad","headerText":"headerText-3dP4N","viewAll":"viewAll-2b81_"};


//////////////////
// WEBPACK FOOTER
// ./src/components/home/workouts/_recentWorkouts.css
// module id = 1220
// module chunks = 1